import { createGlobalStyle } from 'styled-components';

export const CustomPdfExtensionStyles = createGlobalStyle`
  /* Asegurar que el wrapper del PDF mantenga su funcionalidad */
  .remirror-pdf-wrapper {
    position: relative;
    width: 100%;
  }

  /* Bloquear solo las páginas del PDF y thumbnails, no los controles */
  .remirror-pdf-wrapper.download-blocked .react-pdf__Page {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    cursor: not-allowed;
  }

  .remirror-pdf-wrapper.download-blocked .react-pdf__Page canvas {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  /* Bloquear thumbnails específicamente */
  .remirror-pdf-wrapper.download-blocked .thumbnail .react-pdf__Page {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    cursor: not-allowed;
  }

  .remirror-pdf-wrapper.download-blocked .thumbnail .react-pdf__Page canvas {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  /* Mantener los controles interactivos */
  .remirror-pdf-wrapper.download-blocked .Toolbar,
  .remirror-pdf-wrapper.download-blocked .Tools,
  .remirror-pdf-wrapper.download-blocked .Button,
  .remirror-pdf-wrapper.download-blocked .Pagination,
  .remirror-pdf-wrapper.download-blocked .Input {
    pointer-events: auto;
    cursor: pointer;
  }
`;
